import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class GoogleCloud extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M21.019,8.261a9.4,9.4,0,0,0-2.832-4.567h0A9.393,9.393,0,0,0,2.894,8.261h0A6.564,6.564,0,0,0,0,13.908,6.771,6.771,0,0,0,2.647,19.24l.007-.007-.007.029a6.728,6.728,0,0,0,4.091,1.361l5.183.033H17.17A6.78,6.78,0,0,0,21.019,8.261ZM17.17,16.483l-5.22-.032H6.738a2.6,2.6,0,0,1-1.07-.232h0A2.606,2.606,0,1,1,9.117,12.77l3.022-3.022A6.761,6.761,0,0,0,8.061,7.215c.021-.013-.018,0,0,0A5.357,5.357,0,0,1,15.3,6.658h0A5.2,5.2,0,0,1,17.17,10.75v.52a2.607,2.607,0,0,1,0,5.213Z" />
      </svg>
    );
  }
}

export default GoogleCloud;
